<template>
    <div class="popup" :class="classObj">
        <van-popup :value="show" :overlay-style="{ background: 'rgba(4, 14, 32, .72)', backdropFilter: 'blur(3px)' }" @click-overlay="close" @open="open">
            <accountForm ref="accountForm" v-if="memberRegisterType == 'UserName'" @close="close" @loginSucc="$emit('loginSucc')"></accountForm>
            <phoneForm ref="phoneForm" v-if="memberRegisterType == 'Phone'" @close="close" @loginSucc="$emit('loginSucc')"></phoneForm>
        </van-popup>
    </div>
</template>

<script>
import accountForm from './accountForm.vue'
import phoneForm from './phoneForm.vue'
import { mapState } from 'vuex'
export default {
    name: 'loginPopup',
    components: { accountForm, phoneForm },
    data() {
        return {}
    },
    props: {
        isCanClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowLoginPopup
            },
            set(val) {
                return val
            }
        },
        memberRegisterType() {
            const memberRegisterType = this.$store.getters.sysConfig?.memberRegisterType
            return memberRegisterType || 'UserName'
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowLoginPopup', false)
            if (!this.isCanClose) {
                this.onPageRefresh()
            }
        },
        open() {
            this.$nextTick(() => {
                if (this.memberRegisterType === 'UserName') {
                    this.$refs.accountForm.open()
                } else if (this.memberRegisterType === 'Phone') {
                    this.$refs.phoneForm.open()
                }
            })
        }
    },
    beforeDestroy() {
        this.$store.dispatch('user/changeLoginType', 2)
        this.$store.dispatch('user/setIsShowLoginPopup', false)
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    .van-popup {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        border-radius: .32rem;
        overflow: hidden;
    }

    ::v-deep .content {
        border-radius: inherit !important;
    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                width: calc(100vw - 12px) !important;
                max-width: calc(100vw - 12px) !important;
                max-height: calc(100vh - 12px) !important;
                background: $bg-popup-color !important;
                border-radius: .35rem !important;
                overflow: hidden !important;
            }
        }
        ::v-deep .content{
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: calc(100vh - 12px) !important;
            border-radius: inherit !important;
            overflow-y: auto;
        }
        ::v-deep .banner_pc {
            display: none;
        }

        ::v-deep .LogReg {
            width: 100% !important;
            height: auto !important;
        }
    }
}</style>
